(function () {
  if (window.__mobileCartCroInit) return;
  window.__mobileCartCroInit = true;

  var refreshTimer = null;
  var SECTION_URL = '/?section_id=pullout-cart-checkout';

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function shouldRefreshRequest(url) {
    if (!url) return false;
    return /\/cart\/(add|change|update)\.js/.test(url);
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function refreshCheckout() {
    if (!isMobile()) return;

    var target = document.querySelector('[data-pullout-cart-checkout]');
    if (!target) return;

    fetch(SECTION_URL)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-pullout-cart-checkout]');

        if (fresh) {
          target.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function (error) {
        console.error('Failed to refresh mobile cart checkout:', error);
      });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCheckout, 150);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var requestUrl = getRequestUrl(arguments[0]);

    return originalFetch.apply(this, arguments).then(function (response) {
      if (shouldRefreshRequest(requestUrl) && response.ok) {
        scheduleRefresh();
      }
      return response;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCheckout);
  } else {
    refreshCheckout();
  }
})();
